import { generateApiUrl } from "@/shared/utils";

/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";

export const getCenterExecuteRoom = async (centerExecuteId, roomId) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteRoom"],
      [centerExecuteId, roomId]
    );
    const response = await httpService.get(url);
    const data = pathOr(null, ["data", "data"], response);
    const permissions = pathOr([], ["data", "permissions"], response);
    return {
      name: pathOr("", ["name"], data),
      link: pathOr(null, ["link"], data),
      capacity: pathOr("", ["capacity"], data),
      description: pathOr("", ["description"], data),
      permissions,
    };
  } catch (error) {
    throw error;
  }
};
export const updateCenterExecuteRoom = async ({
  centerExecuteId,
  roomId,
  name,
  link,
  capacity,
  description,
}) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteRoom"],
      [centerExecuteId, roomId]
    );
    const payload = {
      name,
      link,
      capacity,
      description,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
